<!-- Splash screen -->
<app-splash-screen />
<!-- Router outlet -->
<router-outlet />
<!-- Google Analaytics 4 -->
<app-google-analytics-gtag />